// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"206":"f8388489","367":"68696027","494":"2673a0d4","643":"f1d6dd53","961":"d9a74b6d"}[chunkId] + ".css";
};